import batchDates from './utils/batchDates';
import getApiParameters from './utils/v3/getApiV3Parameters';
import parseApiResponse from './utils/v3/parseApiV3Response';
import TimeslotsResource from './TimeslotsResource';

/**
 * @class TimesApi
*/
export default class TimesApi {
    constructor(options) {
        this.responseActions = options.responseActions;
    }

    async _getTimesForBatch(batch, state) {
        const startDate = batch[0];
        const numDays = batch.length;
        const apiParameters = getApiParameters(state, startDate, numDays);
        const httpResponse = await TimeslotsResource.fetch(apiParameters, {
            credentials: 'same-origin',
        });

        const response = await httpResponse.json();
        const parsedResponse = parseApiResponse(response, batch, state);

        this.responseActions.receiveTimes(parsedResponse, state.isExistingPatient);
    }

    /**
     * @param {TimesGridState} state
     * @param {Array<moment>} dates
     */
    getTimes(state, dates) {
        if (state.doctorLocationIds.length === 0) {
            return Promise.resolve();
        }

        const batches = batchDates(dates);

        return Promise.all(batches.map(batch => this._getTimesForBatch(batch, state)));
    }
}
